import React, {useState} from "react";
import Form from "react-bootstrap/Form";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import DatePicker from 'react-datepicker';
import Select from 'react-select';

function NewJobsheet (){
  const [startDate, setStartDate] = useState(new Date());
  return(
    <Form>
      <Row className="mt-3">
        <Col className="rounded border border-3 border-dark">
          <div className="p-3 text-center"><h1>Jobsheet</h1></div>
          <div className="justify-content-center d-flex">
            <Form.Group className="text-center">
              <Form.Check
                reverse
                label="Gripper"
                name="group1"
                type='checkbox'
              />
              <Form.Check
                reverse
                label="Underlay"
                name="group1"
                type='checkbox'
              />
              <Form.Check
                reverse
                label="Metals"
                name="group1"
                type='checkbox'
              />
              <Form.Check
                reverse
                label="Floor Prep"
                name="group1"
                type='checkbox'
              />
              <Form.Check
                reverse
                label="Intec"
                name="group1"
                type='checkbox'
              />
              <Form.Check
                reverse
                label="Glues"
                name="group1"
                type='checkbox'
              />
              <Form.Check
                reverse
                label="Plywood"
                name="group1"
                type='checkbox'
              />
              <Form.Check
                reverse
                label="Screed"
                name="group1"
                type='checkbox'
              />
              <Form.Check
                reverse
                label="Staple Gun"
                name="group1"
                type='checkbox'
              />
            </Form.Group>
          </div>
          <Row className="border-top border-2 border-dark mt-3">
              <div className="p-3"><h2>Job Scope</h2></div>
              <FloatingLabel id="label" label="Job Scope" className='mb-3'>
                <Form.Control as="textarea"
                  type="string"
                  required
                />
              </FloatingLabel>
          </Row>
        </Col>
        <Col className="col-4">
          <Form.Group className="rounded border border-3 border-dark p-3 mb-1">
            <Form.Text id="d" muted>
              Customer Name
              <FloatingLabel id="label" label="Customer Name" className='mb-3'>
                <Form.Control
                  type="string"
                  id="customer_name"
                  required
                />
              </FloatingLabel>
            </Form.Text>
            <Form.Text id="d" muted>
              Customer Number
              <FloatingLabel id="label" label="Phone Number" className='mb-3'>
                <Form.Control
                  type="string"
                  id="customer_number"
                  required
                />
              </FloatingLabel>
            </Form.Text>
          </Form.Group>

          <Form.Group className="rounded border border-3 border-dark p-3 mb-1">
            <Form.Text id="d" muted>
              Customer Address
              <Select className="mb-3" />
              <FloatingLabel id="label" label="Address" className='mb-3'>
                <Form.Control as="textarea"
                  type="string"
                  id="customer_address"
                  required
                  readOnly
                />
              </FloatingLabel>
            </Form.Text>
          </Form.Group>

          <Form.Group className="rounded border border-3 border-dark p-3 mb-1">
            <Form.Text id="d" muted>
              Date
              <DatePicker selected={startDate} onChange={(date) => setStartDate(date)} />
            </Form.Text>
          </Form.Group>

          <Form.Group className="rounded border border-3 border-dark p-3 mb-1">
            <Form.Text id="d" muted>
              Info
              <FloatingLabel id="label" label="Info" className='mb-3'>
                <Form.Control
                  type="number"
                  min="0"
                  placeholder="Quantity"
                  id="Quantity"
                  required
                />
              </FloatingLabel>
            </Form.Text>
          </Form.Group>
          <Form.Group className="rounded border border-3 border-dark p-3">
            <Form.Text id="d" muted>
              J Number
              <FloatingLabel id="label" label="J Number" className='mb-3'>
                <Form.Control
                  type="number"
                  min="0"
                  placeholder="J Number"
                  id="Quantity"
                  required
                />
              </FloatingLabel>
            </Form.Text>
            <Form.Text id="d" muted>
              Estimate Number
              <FloatingLabel id="label" label="Estimate Number" className='mb-3'>
                <Form.Control
                  type="number"
                  min="0"
                  placeholder="Estimate Number"
                  id="Quantity"
                  required
                />
              </FloatingLabel>
            </Form.Text>
          </Form.Group>
        </Col>
      </Row>
    </Form>
  );
}

export default NewJobsheet
